import PropTypes from "prop-types";
import React from "react";
import {MSpinner} from "components/Shared";

const Photos = ({
  isFetching,
  photos,
  token
}) => {
  if (isFetching) {
    return <MSpinner/>;
  }

  if (!photos) {
    return <MSpinner/>;
  }
   
  return (
    <div className="case-header md-grid">
      <iframe
        id="CasePhotoList"
        name="CasePhotoList"
        width="100%"
        height="520"
        src={photos.iframeUrlTemplate + "&SSO=" + encodeURI(token) + "&DisplayMode=Standard"}
        style={{borderWidth: 0}}
        scrolling="no"
       />
    </div>);
};

Photos.propTypes = {
  isFetching: PropTypes.bool.isRequired,
  photos: PropTypes.object.isRequired,
  token: PropTypes.string
};

export default Photos;